import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { Link } from 'react-router-dom';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { pluralize } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportSuccessDialog/utils/pluralize';
import { ImportFile } from 'types/embedded/bankOperation';

type Props = {
  open: boolean;
  onClose: () => void;
  record?: ImportFile;
};

export const RequestsBankOpsImportSuccessDialog: React.FC<Props> = ({ open, onClose, record }) => {
  const validRows = record?.validRows || 0;
  const { verb, noun } = pluralize(validRows);

  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery({ resource: Resources.RequestBankOperations, type: 'list' });

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        title="Загрузка заявок успешно завершена"
        titleSize="smallBold"
      />
      <CardContent>
        <Box>
          <Typography variant="body1">Загрузка заявок на БО успешно завершена.</Typography>
          <Typography mt={2} variant="body1">
            {`${verb} ${validRows} ${noun} на БО.`}
          </Typography>
        </Box>
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <Button key="cancel" label="Закрыть" onClick={onClose} variant="outlined" />,
          <Button
            color="primary"
            component={Link}
            key="list"
            label="Перейти к просмотру"
            onClick={onClose}
            to={to}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
